import { AVATAR_GROUP } from "./constants.js";
const en = {
    [AVATAR_GROUP]: {
        MEMBERS: 'Members'
    }
};
export { en };
